<header>
    <div class="wrap">
        <div class="text">
            <h1 class="title mt-3">
                <span class="text">{{title}}</span>
            </h1>

            <div [innerHTML]="message | safeHtml"></div>

            <div class="text-center" style="margin-top: 30px;">
                <ng-casto-btn
                  class="blue validate"
                  label="{{validateBtn}}"
                  (click)="modalService.close(true)"
                ></ng-casto-btn>
            </div>
        </div>
    
        <div class="header-actions">
          <button class="close" (click)="modalService.close(false)" title="Fermer">
            <span class="icon-view-close" aria-hidden="true">
              <svg>
                <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
              </svg>
            </span>
            <span>Fermer</span>
          </button>
        </div>
    
    </div>
    </header>
    
    <div class="main">
    </div>
    
